import { Version } from './Version';
export class NullVersion extends Version {
    constructor() {
        super('', '');
    }
    fulfills() {
        return false;
    }
}
